import { pdf } from '@react-pdf/renderer';
import axios from 'axios';
import { toDataURL } from 'qrcode';
import { api } from 'api/api';
import { Endpoints } from 'api/constants';
import { IFile } from 'types/income';
import { getFormData } from 'utils/general';

interface GetFile {
  fileId: string;
}

interface GetFiles {
  fileIds: string[];
}

interface UploadFile {
  file: File;
  neverExpires?: boolean;
}

interface GetPdfBlob {
  filename: string;
  document: Parameters<typeof pdf>[0];
}

interface GenerateQrCodeDataUrl {
  text: string;
}

export const loaders = {
  getFile: ({ fileId }: GetFile) => {
    return api<IFile>({
      url: Endpoints.files.byId.replace(':fileId', fileId),
    });
  },
  downloadFile: async ({ fileId }: GetFile) => {
    const { data: file } = await loaders.getFile({ fileId });

    const response = await axios.get<ArrayBuffer>(file.signedUrl, {
      responseType: 'arraybuffer',
    });

    response.headers[
      'content-disposition'
    ] = `attachment; filename="${file.fileName}"`;

    return response;
  },
  getFiles: ({ fileIds }: GetFiles) => {
    return Promise.all(
      fileIds.map((fileId) => loaders.getFile({ fileId })),
    ).then((res) => ({
      data: res.map(({ data }) => data).flat(),
    }));
  },
  uploadFile: ({ file, neverExpires }: UploadFile) => {
    return api<IFile>({
      url: Endpoints.files.upload,
      method: 'post',
      data: getFormData([
        { field: 'file', value: file },
        ...(neverExpires
          ? [{ field: 'neverExpires', value: String(neverExpires) }]
          : []),
      ]),
    });
  },
  getPdfBlob: ({ document }: GetPdfBlob) => {
    return pdf(document).toBlob();
  },
  generateQrCodeDataUrl: ({ text }: GenerateQrCodeDataUrl) => {
    return toDataURL(text);
  },
};
